import Phaser from 'phaser';

const BG_OUTER = 0x0f172a;
const BG_INNER = 0x1e3a8a;
const HEAD_LIGHT = 0xe5e7eb;
const HEAD_DARK = 0x9ca3af;
const HEAD_ACCENT = 0xfbbf24;
const HANDLE = 0x7c5a2b;
const STROKE = 0x0a0f1f;

export function drawHammer(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const handleW = r * 0.2;
  const handleH = r * 1.1;
  g.fillStyle(HANDLE, 1);
  g.lineStyle(Math.max(1, Math.floor(stroke * 0.7)), STROKE, 1);
  g.fillRoundedRect(-handleW / 2, -r * 0.05, handleW, handleH, r * 0.05);
  g.strokeRoundedRect(-handleW / 2, -r * 0.05, handleW, handleH, r * 0.05);

  const headW = r * 1.2;
  const headH = r * 0.58;
  const headY = -r * 0.45;
  g.fillStyle(HEAD_LIGHT, 1);
  g.fillRoundedRect(-headW / 2, headY, headW, headH, r * 0.08);
  g.strokeRoundedRect(-headW / 2, headY, headW, headH, r * 0.08);

  g.fillStyle(HEAD_DARK, 1);
  g.fillRect(-headW / 2 + r * 0.06, headY + headH * 0.62, headW - r * 0.12, headH * 0.22);

  g.fillStyle(HEAD_ACCENT, 1);
  g.fillRect(-r * 0.1, headY + headH * 0.3, r * 0.2, r * 0.14);
}
